// extracted by mini-css-extract-plugin
export default {"LogoScrolled":"czsjobPqcMsAvFGQowEI","active":"YVReZmqS9yAFvEYvXfIj"};